import { FaHotel } from "react-icons/fa";
import { DateRangeFilter } from "../reportSummary/DateRangeFilter";

export function HotelDashboardHeader({ onDateRangeChange }) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-[#1E61DC]/10 flex items-center justify-center">
          <FaHotel className="w-6 h-6 text-[#1E61DC]" />
        </div>
        <div>
          <span className="text-[#1A1A1A] text-xl">
            Hotels Revenue Dashboard
          </span>
          <p className="text-[#6B7280]">
            Hotel booking performance and accommodation insights
          </p>
        </div>
      </div>
      <DateRangeFilter onChange={onDateRangeChange} />
    </div>
  );
}
